module.exports = __webpack_public_path__ + "img/icon-core2-3.c2ce4940.png";